import { Box, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import type { FC } from 'react';
import { getPageTitle } from 'src/config/projectConfig';

type SecuritySectionPlaceholderProps = {
  title: string;
};

const SecuritySectionPlaceholder: FC<SecuritySectionPlaceholderProps> = ({ title }) => (
  <>
    <Helmet>
      <title>{getPageTitle(`Security — ${title}`)}</title>
    </Helmet>
    <Box p={3}>
      <Typography variant="h4" fontWeight={600} gutterBottom>
        {title}
      </Typography>
      <Typography variant="body1" color="textSecondary">
        Under Development
      </Typography>
    </Box>
  </>
);

export default SecuritySectionPlaceholder;
